import React from 'react';
import Login from "./Login";
import Logout from "./Logout";
import {connect} from "react-redux";
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import AccessTokens from "./AccessTokens";
import ErrorBoundary from "./ErrorBoundary";
import {Col, Row} from "react-bootstrap";
import Payments from "./Payments";
import MessagePage from "./MessagePage";
import SandboxPayments from "./SandboxPayments";
import logo from "../../assets/img/lombard_logo.jpg";
const I18n = require('react-redux-i18n').I18n;

const Translate = require('react-redux-i18n').Translate;

const stateMap = (store) => {
    return {
        user: store.user
    };
};

class App extends React.Component {

  render() {
      const loggedIn = this.props.user.entity.fetched;
      const showLogoutBtn = loggedIn &&
          !window.location.pathname.startsWith("/payment") &&
          !window.location.pathname.startsWith("/message");
      return (
          <BrowserRouter>
              <React.Fragment>
                <header>
                    <Row className="justify-content-md-center">
                        <Col lg="8">
                            <Row className="justify-content-space-between align-items-end">
                                <div className="logo">
                                  <img className="logo" alt="lombard's logo" src={logo}/>
                                </div>
                                {showLogoutBtn ?
                                <a className="logout" href='/logout'>
                                    <span  className={'fa fa-sign-out'}  title={I18n.t("logout")} />
                                </a>:null}
                            </Row>
                        </Col>
                    </Row>
                </header>
                <main>
                  <ErrorBoundary>
                      <Switch>
                          <Route exact path="/" render={props => <Redirect to="/accessTokens"/>}/>
                          <Route exact path="/login" render={props =>
                              <Login {...props}/>}>
                          </Route>
                          <Route exact path='/message' component={MessagePage} />
                          <Route exact path='/payment/authentication' component={Payments} />
                          <Route exact path='/sandbox/payment/authentication' component={SandboxPayments} />
                          <Route path="/logout" render={props => <Logout {...props}/>}/>
                          <Route path='/accessTokens' component={AccessTokens}/>
                          {/*Route to '/' path must be put last for proper rendering*/}
                          <Route path='/' component={AccessTokens}/>
                      </Switch>
                  </ErrorBoundary>
                <div className="push"></div>
                </main>
                <footer>
                    <section className="footer-content">
                        <Translate value={"copyright"} />
                        <span>
                            {new Date().getFullYear()}
                        </span>
                    </section>

                </footer>
              </React.Fragment>
          </BrowserRouter>
      );
    }
}

export default connect(stateMap)(App);
